import { CreditException } from '@indigo-ag/schema';
import { creditExceptionsTranslations } from 'shared';

export const getExceptionText = (exception: string) => {
  const isOtherException = !Object.values(CreditException).includes(exception as CreditException);
  if (isOtherException) {
    return `${creditExceptionsTranslations[CreditException.OTHER]}: ${exception}`;
  }
  return creditExceptionsTranslations[exception as CreditException];
};
